<template>
  <!-- 登录 -->
  <div class="login-box">
    <div class="login">
      <a-form-model :model="form" style="width: 250px">
        <div class="login-title">飞碟管理系统</div>
        <a-form-model-item>
          <a-input
            @keyup.enter="submitForm('ruleForm')"
            v-model="form.name"
            placeholder="账号"
            class="zzzzz"
            :maxLength="20"
          >
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input-password
            @keyup.enter="submitForm('ruleForm')"
            v-model="form.pawd"
            class="zzzzz"
            placeholder="密码"
            :maxLength="20"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input-password>
        </a-form-model-item>
        <a-alert
          v-show="login_message_control"
          type="error"
          :message="login_message"
          banner
        />
        <a-button
          type="primary"
          class="login-botton"
          @click="submitForm('ruleForm')"
          :loading="login_loading"
        >
          登录
        </a-button>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { postLogin, demoLogin } from "@/request/api";

export default {
  name: "login",
  data() {
    return {
      message: " ",
      form: {
        name: "",
        pawd: "",
      },
      login_message: "", // 登录状态内容
      login_message_control: false, // 不显示错误提示
      login_loading: false, // 登录按钮的节流控制

      not_log_control: true, // 表示正常通行。如果是登录过期来的就要改为false
    };
  },
  mounted() {
    let that = this;

    // 会有从其他渠道进入登录的入口，避免进来然后点击浏览器的后退按钮，返回其他页面，在这里把登录信息清除。2022-6-24
    // localStorage.setItem("access_token","")
    // 产品需求更改，这里就不需要了，注销。产品希望登录状态进入到登录页面自动前往一个页面。前往顶部菜单的第一个页面。2022-8-10

    if (this.$route.params.type == "not_log") {
      // 增加登录过期跳过来的提示
      this.$message.warning("登录状态过期，重新登录");
      this.not_log_control = false;
    } else {
      // 用于避免其他页面刷新，然后home页面重新拿数据，然后跳到菜单项的第一个页面去了
      localStorage.setItem("login_home_path", "login");

      this.not_log_control = true;
    }

    // console.log("route_login_to",sessionStorage.getItem('route_login_to'))

    // 如果登录信息还没有过期，自动调往菜单项的第一个页面。菜单项要在home页面获取。2022-8-10
    if (localStorage.getItem("access_token")) {
      that.$router.push({ path: "/home" });
    }

    // postLogin().then(res=>{
    // 	console.log(res)
    // })
  },
  methods: {
    submitForm(formName) {
      let vm = this;
      // console.log(vm.form)
      this.login_loading = true;
      postLogin({
        username: vm.form.name,
        password: vm.form.pawd,
      })
        .then((res) => {
          this.login_loading = false;
          console.log("登录", res);
          if (
            res.data.code === 0 ||
            res.data.code === 200 ||
            res.data.code == 8011
          ) {
            localStorage.setItem("access_token", res.data.data.access_token);

            // 保存用户身份识别符，用于控制页面权限
            localStorage.setItem(
              "role_limits",
              JSON.stringify(res.data.data.role)
            );

            // 用户产品线
            // const _temp = res.data.data.role.includes(1) ? [1, 2, 3, 4] : [];
            const temp = res.data.data.channel_content_type || [];
            localStorage.setItem("channel_content_type", JSON.stringify(temp));
            console.log(`channel_content_type`);

            // 存用户身份，用于页面水印
            localStorage.setItem("user_name_identity", res.data.data.name);

            // 存用户登录账户
            localStorage.setItem("user_login_account", vm.form.name);

            // 存用户ID
            localStorage.setItem("user_id_storage", res.data.data.user_id);


            console.log(res.data.data)

            // console.log(localStorage.getItem("access_token"))
            if (vm.not_log_control) {
              // 正常登录流程
              vm.$router.push({ path: "/home" });
            } else {
              // 登录过期后重新登录的跳转
              let route_name = sessionStorage.getItem("route_login_form");
              vm.$router.push({ name: route_name });
            }
          } else {
            vm.login_message = res.data.msg;
            vm.login_message_control = true;
          }
        })
        .catch((err) => {
          vm.login_loading = false;
          vm.$message.error(`${err}`);
        });
    },
  },
};
</script>

<style scoped>
.login-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: #fff;
}

.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 350px;
  margin-bottom: 120px;
  margin-right: 80px;
}
.login-title {
  font-size: 20px;
  text-align: center;
  line-height: 90px;
  font-weight: bold;
  color: #03a9f4;
}
.login-botton {
  margin-top: 20px;
  width: 100%;
  height: 40px;
}
.message {
  margin: 0;
  margin-left: 50px;
  height: 16px;
  line-height: 16px;
  color: #f56c6c;
  font-size: 12px;
}
/* elementUI样式 */
.el-form {
  width: 300px !important;
}
.el-form-item__label {
  width: 60px !important;
  text-align: center !important;
}
.el-form-item__content {
  margin-left: 0 !important;
}
</style>
